import { render } from "./ContainerIcon.vue?vue&type=template&id=0fb764e1"
import script from "./ContainerIcon.vue?vue&type=script&lang=js"
export * from "./ContainerIcon.vue?vue&type=script&lang=js"

import exportComponent from "/container/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__